export default __webpack_public_path__ + "e639aa1860274ba6e4e7bf67d36c9e8b.svg";